/**
 * Reserva Preismatrix
 */

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var moment = require('moment');

var DateTime = require('DateTime');
var FormModel = require('../engine/models/FormModel');
var MiniTimer = require('MiniTimer');

var ReservaPriceTableView = require('./ReservaPriceTableView.js');

var ReservaPriceTable = Backbone.Model.extend({

	defaults: function() {
		return {
			groups: [],
			info: "",
			from: null,
			to: null,
			nights: 0,
			model: null,
			container: null,
			viewData: null,

			renderOffset: 0,
			renderDaysCount: 7,
			canGoFurther: true,
		}
	},

	initialize: function() {
		_.bindAll(this, "updateViewState");

		this.container = this.get("container");
		this.model = this.get("model") || new FormModel();

		this.startDay = DateTime.resetTimeFields(moment());

		this.view = new ReservaPriceTableView({
			el: this.container,
			model: this,
		});

		/* Bubble the event up */
		this.on("pricetableClick", function(data) {
			this.get("model").trigger("pricetableClick", data);
		}.bind(this))

		this.dateCache = {};
		for(var i = 0; i <= 521; i++) {
			this.dateCache[i] = this.startDay.clone().add(i + 1, 'days');
		}
	},

	/**
	 * Die TimeTable initialisieren und rendern
	 */
	run: function() {
		this.updateDate();

		this.on('change:renderOffset change:renderDaysCount', () => {
			this.updateViewState();
		});

		/* Responsive Width Test */
		let timer = MiniTimer("Test rendering for column width");
		timer();

		$(window).on('resize', _.debounce(this.updateViewState, 300));

		/* Bei Änderungen am Model die Auswahl aktualisieren */
		this.model.on('change:to change:select_mode', (e) => {
			/* Leichte Verzögerung um die UI nicht so stark zu blockieren */
			setTimeout(function() {
				this.updateDate();
				this.updateViewState();
			}.bind(this), 100);
		});
	},

	updateDate: function() {
		let from = this.model.get("from");
		let to = this.model.get("to");
		let select_mode = this.model.get("select_mode") || "exact";

		/* Entweder gibt es Start UND Ende, oder gar keine Auswahl */
		if ( from && to && select_mode === "exact" ) {
			from = DateTime.resetTimeFields(DateTime.parse(from));
			to = DateTime.resetTimeFields(DateTime.parse(to));
		} else {
			from = null;
			to = null;
		}

		this.set({
			from: from,
			to: to,
			nights: to ? to.diff(from, 'days') : 0,
			renderOffset: from ? Math.max(0, from.diff(this.startDay, 'days') - 1) : 0,
		});
	},

	/**
	 * Server-Rückgabe verarbeiten:
	 * - groups[*].offers[*].values 		=> in floats casten
	 * - groups[*].offers[*].values_display => erzeugen (Werte für die Ausgabe)
	 *
	 * @param response {Object} Server-Rückgabe
	 */
	handleResponse: function(response) {
		_.each(response.groups, function(group) {
			_.each(group.offers, function(offer) {
				offer.values = _.map(offer.values, (v) => parseFloat(v));
				offer.values_display = _.map(offer.values, (v) => {
					if ( v === 0 || v > 9999 ) return "";
					return Math.abs(v).toFixed(2).replace('.', ',');
				});
			});
		});
		this.startDay = DateTime.resetTimeFields(moment(response.start));
		this.set({
			groups: response.groups,
			info: response.info,
		});
		this.updateViewState();
	},

	setRenderOffset: function(new_offset) {
		let groups = this.get("groups");
		if ( new_offset < 0 ) {
			new_offset = 0;
		}

		if ( groups && groups[0] ) {
			let maxOffset = groups[0].offers[0].values.length - this.get("renderDaysCount");
			new_offset = Math.min(new_offset, maxOffset);

			this.set({
				"renderOffset": new_offset,
				"canGoFurther": new_offset < maxOffset,
			});
		} else  {
			this.set({
				"renderOffset": 0,
				"canGoFurther": false,
			});
		}
	},

	updateViewState: function(e) {
		var timer = MiniTimer("ReservaPriceTable.updateViewState");

		if ( !this.get("to") ) {
			this.set("viewData", {});
			return;
		}

		var container = this.view.$el;

		var cellWidth = 65;
		var titleWidth = container.find('tbody .kat').width();

		console.log("[PriceTable] Cell width is " + cellWidth + "px");
		console.log("[PriceTable] Title width is " + titleWidth + "px");

		var containerMaxWidth = container.width();
		var cellsToDisplay = Math.floor( ( containerMaxWidth - 200) / cellWidth ) - 1;
		cellsToDisplay = Math.max(cellsToDisplay, 3);

		console.log("[PriceTable] cellsToDisplay", cellsToDisplay);

		this.set({
			"renderDaysCount": cellsToDisplay,
			"titleWidth": titleWidth,
		}, { silent: true });

		let renderOffset = this.get("renderOffset");
		let renderDaysCount = this.get("renderDaysCount");

		let months = [];
		let monthCounters = {};
		let days = [];

		/* Highlight currently selected timerange */

		/* Make list of all days we're going to render, and group them by month */
		var makeMonths = function(short_map) {
			short_map = short_map || {};
			months = [];
			days = [];
			monthCounters = {};

			for(let i = 0; i < renderDaysCount; ++i) {
				let day	= this.startDay.clone().add(i + renderOffset, 'days');
				let monthname = day.format('MMMM YYYY');
				if ( typeof short_map[monthname] !== "undefined" ) {
					monthname = day.format(short_map[monthname]);
				}

				if ( months.indexOf(monthname) === -1 ) {
					months.push(monthname);
					monthCounters[monthname] = 0;
				}
				monthCounters[monthname]++;

				days.push({
					index: i + renderOffset,
					line1: day.format('dddd'),
					line2: day.format('D. MMM').replace(' ', '&nbsp;').replace('Febr.', 'Feb.').replace('Mrz.', 'März').replace('Jun.', 'Juni').replace('Jul.', 'Juli'),
					date: day.format('YYYY-MM-DD'),
					weekend: (day.day() === 0 || day.day() === 6),
					selected: this.get("from") && this.get("from").format("YYYY-MM-DD") == day.format('YYYY-MM-DD'),
				});
			}
		}.bind(this);
		makeMonths();

		/* Schauen ob wir die Monatsnamen kürzen müssen */
		_.each(monthCounters, function(count, month) {
			/* Wenn wir nur einen Monat haben, ist selbst "Nov." zu lang */
			if ( count === 1 ) {
				var mapping = {};
				mapping[month] = ' '; /* Achtung: Empty string führt zu YYYY-MM-DD */
				makeMonths(mapping);
			}
			/* Bei weniger als 4 Tagen kürzen wir auf z. B. "Nov." statt "November 2015" */
			else if ( count < 4 ) {
				var mapping = {};
				mapping[month] = 'MMM';
				makeMonths(mapping);
			}
		});

		/* Klassen erzeugen */
		let groups = [];
		_.each(this.get("groups"), function(group) {
			let offers = [];
			_.each(group.offers, function(offer) {
				offers.push({
					...offer,
					values: offer.values.slice(renderOffset, renderOffset + renderDaysCount),
					values_display: offer.values_display.slice(renderOffset, renderOffset + renderDaysCount),
				});
			});

			groups.push({
				...group,
				offers: offers,
			});
		});

		timer();

		/* Alles zusammen packen und dann rendern */
		this.set("viewData", {
			months: months,
			monthCounters: monthCounters,
			days: days,
			groups: groups,
			info: this.get("info"),
			renderDaysCount: renderDaysCount,
			renderOffset: renderOffset,
			canGoFurther: this.get("canGoFurther"),
			developer: location.host.indexOf("localhost") !== -1,
			selectedNightString: this.get("from") ? this.get("from").format("YYYY-MM-DD") : "",
		});

	},


});


module.exports = ReservaPriceTable;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/pricetable/index.js
 **/